"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersModel = void 0;
var queryString_1 = require("../helpers/queryString");
var OrdersModel = /** @class */ (function () {
    function OrdersModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + '/api/v1/crm/orders',
            UPDATE: APPURL + '/api/v1/crm/orders',
            CREATE: APPURL + '/api/v1/crm/orders'
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    OrdersModel.prototype.extract = function (result) {
        return result.data;
    };
    OrdersModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    OrdersModel.prototype.show = function (id) {
        return this.$http.get(this.URLS.FETCH + '/' + id).then(this.cacheResults);
    };
    OrdersModel.prototype.getDetails = function (order) {
        return this.$http.get("".concat(this.URLS.FETCH, "/").concat(order.id, "/details")).then(this.cacheResults);
    };
    OrdersModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        if (data !== null) {
            return this.$http.get(this.URLS.FETCH + '?' + (0, queryString_1.toQueryString)(data)).then(this.cacheResults);
        }
        return this.$http.get(this.URLS.FETCH).then(this.cacheResults);
    };
    ;
    OrdersModel.prototype.update = function (request) {
        return this.$http.put(this.URLS.FETCH + '/' + request.id, request).then(this.cacheResults);
    };
    ;
    OrdersModel.prototype.create = function (request) {
        return this.$http.post(this.URLS.FETCH, request).then(this.cacheResults);
    };
    ;
    OrdersModel.prototype.delete = function (data) {
        return this.$http.delete(this.URLS.FETCH + '/' + data.id).then(this.cacheResults);
    };
    ;
    OrdersModel.prototype.search = function (params) {
        return this.$http.post(this.URLS.FETCH + '/search', params).then(this.cacheResults);
    };
    ;
    OrdersModel.prototype.submitPayment = function (data) {
        return this.$http.post("".concat(this.URLS.FETCH, "/").concat(data.order_id, "/payments"), data).then(this.cacheResults);
    };
    OrdersModel.prototype.reports = function (data) {
        return this.$http.get("".concat(this.URLS.FETCH, "/reports?").concat((0, queryString_1.toQueryString)(data))).then(this.cacheResults);
    };
    OrdersModel.prototype.voidOrder = function (order_id) {
        return this.$http.post("".concat(this.URLS.FETCH, "/").concat(order_id, "/void"), {}).then(this.cacheResults);
    };
    OrdersModel.prototype.refundOrder = function (order_id) {
        return this.$http.post("".concat(this.URLS.FETCH, "/").concat(order_id, "/refund"), {}).then(this.cacheResults);
    };
    OrdersModel.prototype.sendOrder = function (order_id, data) {
        return this.$http.post("".concat(this.URLS.FETCH, "/").concat(order_id, "/send"), data).then(this.cacheResults);
    };
    OrdersModel.prototype.printOrder = function (order_id) {
        return this.$http.post("".concat(this.URLS.FETCH, "/").concat(order_id, "/print"), {}).then(this.cacheResults);
    };
    OrdersModel.prototype.validateOrderForm = function (data) {
        return this.$http.post("".concat(this.APPURL, "/api/v1/crm/order-form/validate"), data).then(this.cacheResults);
    };
    OrdersModel.prototype.validatePaymentForm = function (data) {
        if (typeof data.order_id === "undefined") {
            throw Error('You must have an order ID in order to validate this form.');
        }
        var order_id = data.order_id;
        delete data.order_id;
        return this.$http.post("".concat(this.APPURL, "/api/v1/crm/orders/").concat(order_id, "/payments/validate"), data).then(this.cacheResults);
    };
    OrdersModel.prototype.getClientToken = function () {
        return this.$http.post("".concat(this.APPURL, "/api/v1/crm/order-form/token"), {}).then(this.cacheResults);
    };
    OrdersModel.prototype.salesReports = function (params) {
        if (params !== null) {
            return this.$http.get(this.URLS.FETCH + '/sales-reports?' + (0, queryString_1.toQueryString)(params)).then(this.cacheResults);
        }
        return this.$http.get(this.URLS.FETCH + '/sales-reports').then(this.cacheResults);
    };
    return OrdersModel;
}());
exports.OrdersModel = OrdersModel;
OrdersModel.$inject = ['$http', 'APPURL'];
exports.default = OrdersModel;
